/**
 * "button|checkbox|file|hidden|image|password|radio|reset|submit|text|password
 */
export var FieldType;
(function (FieldType) {
    FieldType["ARRAY"] = "array";
    FieldType["BOOLEAN"] = "checkbox";
    FieldType["CHECKBOX"] = "checkbox";
    FieldType["ENUM"] = "enum";
    FieldType["NUMBER"] = "number";
    FieldType["PASSWORD"] = "password";
    FieldType["TEXT"] = "text";
    FieldType["EMAIL"] = "email";
    FieldType["SELECT"] = "select";
    FieldType["SELECT_MULTIPLE"] = "select-multiple";
})(FieldType || (FieldType = {}));
export var InsertPosition;
(function (InsertPosition) {
    InsertPosition[InsertPosition["BEFORE"] = 0] = "BEFORE";
    InsertPosition[InsertPosition["AFTER"] = 1] = "AFTER";
})(InsertPosition || (InsertPosition = {}));
